// Documento imprimible reutilizable para inventario (recepción, transferencia,
// ajuste). Usa el kit del repo (Imprimible/PrintButton de components/print/DocPrint):
// al imprimir solo sale el documento con el encabezado de marca (logo + empresa).
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PanelIntegrado } from '@/components/ui/PanelIntegrado';
import { Imprimible, PrintButton } from '@/components/print/DocPrint';

export interface DocMeta { label: string; value: ReactNode }
export interface DocColumn { header: string; right?: boolean }

export function DocumentoImprimible({
  titulo, codigo, meta, columns, filas, totalLabel, totalValue, onClose,
}: {
  titulo: string;
  codigo: string;
  meta: DocMeta[];
  columns: DocColumn[];
  filas: ReactNode[][];
  totalLabel?: string;
  totalValue?: ReactNode;
  onClose: () => void;
}) {
  const { t } = useTranslation('inventario');
  return (
    <PanelIntegrado title={`${titulo} · ${codigo}`} onClose={onClose}>
      <div className="flex justify-end">
        <PrintButton />
      </div>
      <Imprimible titulo={titulo} subtitulo={`${t('comun.n_col')} ${codigo}`}>
        <div className="mb-4 grid grid-cols-2 gap-x-6 gap-y-1 text-sm">
          {meta.map((m, i) => (
            <div key={i} className="flex gap-2">
              <span className="text-gray-500">{m.label}:</span>
              <span className="font-medium">{m.value}</span>
            </div>
          ))}
        </div>
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr className="border-b border-black/40 text-left">
              {columns.map((c, i) => (
                <th key={i} className={`py-1 pr-2 ${c.right ? 'text-right' : ''}`}>{c.header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filas.length === 0 && (
              <tr><td colSpan={columns.length} className="py-3 text-center text-gray-500">{t('comun.sin_lineas')}</td></tr>
            )}
            {filas.map((row, i) => (
              <tr key={i} className="border-b border-black/10">
                {row.map((cell, j) => (
                  <td key={j} className={`py-1 pr-2 ${columns[j]?.right ? 'text-right' : ''}`}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
          {totalLabel && (
            <tfoot>
              <tr className="border-t border-black/40 font-semibold">
                <td className="py-1 pr-2" colSpan={Math.max(1, columns.length - 1)}>{totalLabel}</td>
                <td className="py-1 pr-2 text-right">{totalValue}</td>
              </tr>
            </tfoot>
          )}
        </table>
      </Imprimible>
    </PanelIntegrado>
  );
}
